import React from 'react';
import { Text } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { Container } from 'styles';
import { useAdvocacyContext } from 'contexts/advocacy';

const getCopy = copyFor('advocacy.explainer');

export const Explainer = () => {
  const { campaign } = useAdvocacyContext();
  const title = campaign.isDefault
    ? getCopy('title.default')
    : getCopy('title.nonDefault');

  return (
    <Container maxWidth="340px">
      <Text textStyle="heading500" margin={{ bottom: '16px' }} tag="h2">
        {title}
      </Text>
      <Text textStyle="paragraph400">{campaign.legislationDescription}</Text>
      <Text textStyle="paragraph400" margin={{ top: '16px' }}>
        {getCopy('paragraph2')}
      </Text>
    </Container>
  );
};
